import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import { REGISTRATIONS_ACTIONS } from "../../../redux/registrations/actions";
import RegistrationsForm from "../../forms/RegistrationsForm";
import { registrationCreating } from "../../../redux/registrations/selectors";
import { CREW_MATERIALS_ACTIONS } from "../../../redux/crewMaterials/actions";
import {
  crewMaterialsLoaded,
  selectCrewMaterials
} from "../../../redux/crewMaterials/selectors";
import { selectEvent } from "../../../redux/preferences/selectors";
import { getCateringOptions } from "../../../services/api/cateringOptions";
import { getMaterialCategories } from "../../../services/api/materialCategories";

class RegistrationsCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      crewMaterialFilters: {
        "page[number]": 1,
        "page[size]": 50,
        sort: "-updated_at",
        include: "crew-member-material-templates"
      }
    };

    this._handleSubmit = this._handleSubmit.bind(this);
  }

  static propTypes = {
    createRequest: PropTypes.func,
    isCreating: PropTypes.bool,
    location: PropTypes.object,
    event: PropTypes.object,
    loadCrewMaterials: PropTypes.func,
    crewMaterials: PropTypes.array,
    materialsLoaded: PropTypes.bool
  };

  UNSAFE_componentWillMount() {
    this.props.loadCrewMaterials(
      this.state.crewMaterialFilters,
      this.props.event.id
    );

    getCateringOptions(this.props.event.id).then(data => {
      this.setState({ cateringOptions: data.data });
    });

    getMaterialCategories().then(response => {
      this.setState({
        materialCategories: response.data.filter(cat => cat.parentId === null)
      });
    });
  }

  _handleSubmit(values) {
    const data = {
      companyId: values.companyId,
      eventId: this.props.event.id,
      sendVouchersToAdmin: values.sendVouchersToAdmin,

      sendCateringInvoice: values.sendCateringInvoice,
      excelImportsAllowed: values.excelImportsAllowed,

      materialRequestsAllowed: values.materialRequestsAllowed,
      transportRequestsAllowed: values.transportRequestsAllowed,
      allDayTransportRequestsAllowed: values.allDayTransportRequestsAllowed,
      frequentPassageRequestsAllowed: values.frequentPassageRequestsAllowed,

      parkings: values.parkings,
      departments: values.departments,
      profiles: values.profiles,
      redirect: values.redirect
    };

    data.crewMemberMaterialTemplateIds = [];
    Object.keys(values).forEach(function(key) {
      if (key.startsWith("material_") && values[key] === true) {
        data.crewMemberMaterialTemplateIds.push(
          parseInt(values[key + "_template"], 10)
        );
      }
    });

    data.allowedCateringOptions = [];
    Object.keys(values).forEach(function(key) {
      if (key.startsWith("cateringoptions_") && values[key] === true) {
        data.allowedCateringOptions.push(
          parseInt(key.replace("cateringoptions_", ""), 10)
        );
      }
    });

    data.materialCategoryIds = [];
    Object.keys(values).forEach(function(key) {
      if (key.startsWith("materialcategories_") && values[key] === true) {
        data.materialCategoryIds.push(
          parseInt(key.replace("materialcategories_", ""), 10)
        );
      }
    });

    this.props.createRequest(data, values.redirect);
  }

  render() {
    const breadcrumbs = [
      {
        title: "Registrations",
        to: "/admin/registrations"
      }
    ];

    const { materialsLoaded, crewMaterials, event, isCreating } = this.props;
    const { cateringOptions, materialCategories } = this.state;

    if (materialsLoaded && cateringOptions && materialCategories) {
      return [
        <AdminSubHeader
          title="Create Registration"
          key="subheader"
          breadcrumbs={breadcrumbs}
        />,
        <div className="m-content" key="content">
          <RegistrationsForm
            onSubmit={this._handleSubmit}
            crewMaterials={crewMaterials}
            isCreating={isCreating}
            event={event}
            cateringOptions={cateringOptions}
            materialCategories={materialCategories}
          />
        </div>
      ];
    }
    return null;
  }
}

const mapStateToProps = function(state) {
  return {
    isCreating: registrationCreating(state),
    crewMaterials: selectCrewMaterials(state),
    event: selectEvent(state),
    materialsLoaded: crewMaterialsLoaded(state)
  };
};

const mapDispatchToProps = dispatch => ({
  createRequest: (values, redirect) =>
    dispatch(REGISTRATIONS_ACTIONS.createRequest(values, redirect)),
  loadCrewMaterials: (filters, eventId) =>
    dispatch(CREW_MATERIALS_ACTIONS.loadAllRequest(filters, eventId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationsCreate);
